import { Controller } from "@hotwired/stimulus";

export default class SelectController extends Controller {
  static targets = ["trigger", "display", "hiddenInput", "option"];
  static values = {
    selected: String,
    name: String,
    placeholder: String,
  };

  connect() {
    this.updateDisplay();
  }

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  selectOption(event) {
    event.preventDefault();
    const optionElement = event.currentTarget;
    const value = optionElement.dataset.selectValue;
    const label = optionElement.querySelector("span").innerHTML;

    // Check if this is a deselection attempt and if the field is required
    if (this.selectedValue === value) {
      const isRequired = this.hiddenInputTarget.hasAttribute("required");
      if (!isRequired) {
        this.selectedValue = "";
        this.updateCheckmarks();
        this.updateDisplay();
        this.updateHiddenInput();
        this.dispatchChangeEvent();
      }
      return;
    }

    this.selectedValue = value;
    this.updateCheckmarks();
    this.updateDisplay(label);
    this.updateHiddenInput();
    this.dispatchChangeEvent();
    this.closeDropdown();
  }

  updateCheckmarks() {
    this.optionTargets.forEach((option) => {
      const value = option.dataset.selectValue;
      const checkmark = option.querySelector(".w-4.h-4");
      const isSelected = value === this.selectedValue;

      if (isSelected) {
        if (!checkmark.querySelector("svg")) {
          checkmark.innerHTML =
            '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>';
        }
      } else {
        checkmark.innerHTML = "";
      }
    });
  }

  updateDisplay(label = null) {
    const displayElement = this.displayTarget;

    if (!this.selectedValue || this.selectedValue === "") {
      displayElement.innerHTML = `<span class="text-muted-foreground">${this.placeholderValue}</span>`;
    } else {
      const displayLabel = label || this.findLabelForValue(this.selectedValue);
      displayElement.innerHTML = displayLabel;
    }
  }

  updateHiddenInput() {
    this.hiddenInputTarget.value = this.selectedValue || "";
  }

  findLabelForValue(value) {
    const option = this.optionTargets.find((opt) => opt.dataset.selectValue === value);
    return option ? option.querySelector("span").innerHTML : value;
  }

  dispatchChangeEvent() {
    // Dispatch change event so it behaves like a select
    const changeEvent = new Event("change", { bubbles: true });
    this.hiddenInputTarget.dispatchEvent(changeEvent);
  }

  closeDropdown() {
    const popoverElement = this.element.querySelector('[data-controller*="ui--popover"]');
    if (popoverElement) {
      const popoverController = this.application.getControllerForElementAndIdentifier(
        popoverElement,
        "ui--popover"
      );
      if (popoverController) {
        popoverController.hide();
      }
    }
  }

  // Public method for programmatically setting the selected value
  setSelectedValue(value) {
    this.selectedValue = value;
    this.updateCheckmarks();
    this.updateDisplay();
    this.updateHiddenInput();
    this.dispatchChangeEvent();
  }
}
